import { useIsDisplayOptimized } from '../transitional/context/DisplayOptimizedContext';
export default function usePlaceholder(placeholder) {
  const isDisplayOptimized = useIsDisplayOptimized();
  if (!placeholder && isDisplayOptimized) {
    return '--';
  }
  return placeholder;
}